import React from "react";
import { motion } from "framer-motion";
import { BookOpen, ArrowUpRight } from "lucide-react";

export function ScienceSection({ section, index }) {
  const alt = index % 2 === 1;
  return (
    <motion.article
      data-testid={`science-section-${section.number}`}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.8, ease: [0.25, 1, 0.5, 1] }}
      className="relative border-t border-white/10 py-14 md:py-20"
    >
      <div className={`grid md:grid-cols-12 gap-8 items-start ${alt ? "" : ""}`}>
        <div className="md:col-span-3">
          <span className="font-display text-6xl sm:text-7xl font-black bg-gradient-to-b from-cyan to-electric bg-clip-text text-transparent">
            {section.number}
          </span>
        </div>
        <div className="md:col-span-9">
          <h3 className="font-display text-3xl sm:text-4xl font-bold text-white">{section.title}</h3>
          <p className="text-ice/75 leading-relaxed mt-5 max-w-3xl text-[1.05rem]">{section.body}</p>

          <div className="mt-8">
            <div className="flex items-center gap-2 label mb-4"><BookOpen size={14} /> Further reading</div>
            <ul className="space-y-3">
              {section.reading.map((r, i) => (
                <li key={i}>
                  {r.href ? (
                    <a href={r.href} target="_blank" rel="noreferrer"
                      className="group inline-flex items-start gap-2 text-ice/80 hover:text-cyan transition-colors">
                      <span className="max-w-2xl">{r.text}</span>
                      <ArrowUpRight size={16} className="mt-1 shrink-0 opacity-60 group-hover:opacity-100" />
                    </a>
                  ) : (
                    <span className="text-ice/70">{r.text}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </motion.article>
  );
}

export default ScienceSection;
